module.exports = __webpack_public_path__ + "img/diversity@2x.0c59a9f.webp";